import { api } from './client';
import type { PoliticsStandingsResponse, VoteForMonarchResult } from '../types/politics';

export async function getKingdomPolitics(
  worldId: string,
  kingdomId: string
): Promise<PoliticsStandingsResponse> {
  const response = await api.get<PoliticsStandingsResponse>(
    `/api/worlds/${worldId}/kingdoms/${kingdomId}/politics`
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to fetch politics');
  }
  return response.data;
}

export async function castVote(
  worldId: string,
  provinceId: string,
  targetProvinceId: string | null
): Promise<VoteForMonarchResult> {
  const response = await api.post<VoteForMonarchResult>(
    `/api/worlds/${worldId}/provinces/${provinceId}/vote`,
    { targetProvinceId }
  );
  if (response.error || !response.data) {
    throw new Error(response.error ?? 'Failed to cast vote');
  }
  return response.data;
}
